import {
  Brain,
  Bot,
  Database,
  Rocket,
  Cloud,
  PenTool,
  Target,
  ShieldCheck,
  Users,
  LineChart,
} from 'lucide-react'

// All brand copy lives here so the company can be renamed in one place.
export const brand = {
  name: 'Nandaki Innovations',
  tagline: 'Intelligent software, engineered for production.',
  email: 'contact@nandakiinnovations.com',
  location: 'Nellore, Andhra Pradesh, India',
}

export const nav = [
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
]

export const hero = {
  eyebrow: 'AI & Software Consultancy',
  title: 'Ship intelligent software, faster.',
  subtitle:
    'We partner with ambitious teams to design, build, and deploy AI products that hold up in the real world — from first prototype to production scale.',
  primaryCta: { label: 'Book a consultation', href: '#contact' },
  secondaryCta: { label: 'Explore services', href: '#services' },
}

export const services = {
  eyebrow: 'What we do',
  title: 'End-to-end expertise, senior from day one',
  subtitle:
    'A focused set of capabilities that take you from idea to a reliable, secure product in production.',
  items: [
    {
      icon: Brain,
      title: 'AI Strategy & Advisory',
      description:
        'Cut through the hype. We help you identify high-leverage use cases and a pragmatic roadmap with clear ROI.',
    },
    {
      icon: Bot,
      title: 'Custom LLM Applications',
      description:
        'Retrieval, agents, and copilots built on your data — evaluated, guardrailed, and ready for real users.',
    },
    {
      icon: Database,
      title: 'Data Engineering',
      description:
        'Reliable pipelines and clean, governed data foundations that make your models trustworthy.',
    },
    {
      icon: Rocket,
      title: 'MLOps & Deployment',
      description:
        'Continuous training, evaluation, and monitoring so your models stay accurate and observable in production.',
    },
    {
      icon: Cloud,
      title: 'Cloud & Platform Engineering',
      description:
        'Scalable, cost-aware infrastructure on AWS, GCP, or Azure — secure by design and built to grow.',
    },
    {
      icon: PenTool,
      title: 'Product Design',
      description:
        'Interfaces that make complex AI feel effortless, grounded in research and rapid iteration.',
    },
  ],
}

export const about = {
  eyebrow: 'Why teams choose us',
  title: 'A partner that ships, not just advises',
  paragraphs: [
    'Nandaki Innovations is a team of engineers, data scientists, and designers building software that people can rely on every day.',
    'We embed with your team, move quickly, and hold ourselves to production standards from the very first commit — no throwaway prototypes, no hand-offs that stall.',
  ],
  pillars: [
    {
      icon: Target,
      title: 'Outcome-driven',
      description: 'We measure success by the metrics that matter to your business, not lines of code.',
    },
    {
      icon: ShieldCheck,
      title: 'Security-first',
      description: 'Privacy, compliance, and data governance are built in from day one, never bolted on.',
    },
    {
      icon: Users,
      title: 'Senior-only teams',
      description: 'You work directly with the people building your product — no layers, no juniors learning on your dime.',
    },
    {
      icon: LineChart,
      title: 'Transparent delivery',
      description: 'Clear milestones, honest timelines, and weekly demos so you always know where things stand.',
    },
  ],
}

export const contact = {
  eyebrow: 'Let’s talk',
  title: 'Have a project in mind?',
  subtitle:
    'Tell us what you’re building. We’ll get back to you within one business day with clear next steps.',
}

export const footer = {
  tagline:
    'Design, build, and ship intelligent software that holds up in the real world.',
  columns: [
    {
      heading: 'Company',
      links: [
        { label: 'Services', href: '#services' },
        { label: 'About', href: '#about' },
      ],
    },
    {
      heading: 'Get started',
      links: [
        { label: 'Contact', href: '#contact' },
        { label: 'Book a consultation', href: '#contact' },
      ],
    },
  ],
}
